import React, { ReactElement, ReactNode } from 'react';
import classes from './PageHeadingBanner.module.css';
import cn from 'classnames';
import { Paragraph } from '../Paragraph';
import { Heading } from '../Heading';

type PageHeaderBannerProps = {
  children: ReactNode;
  className?: string;
};

type PageHeaderBannerSubElementsProps = PageHeaderBannerProps;

export const PageHeadingBanner = ({
  children,
  className,
}: PageHeaderBannerProps): ReactElement => {
  const combinedClassName = cn(classes.banner, className);

  return <div className={combinedClassName}>{children}</div>;
};

PageHeadingBanner.Title = function Title({
  children,
  className,
}: PageHeaderBannerSubElementsProps) {
  const combinedClassName = cn(classes.title, className);
  return (
    <Heading as="h2" className={combinedClassName}>
      {children}
    </Heading>
  );
};

PageHeadingBanner.Text = function Text({
  children,
  className,
}: PageHeaderBannerSubElementsProps) {
  const combinedClassName = cn(classes.text, className);
  return (
    <Paragraph size="ml" className={combinedClassName}>
      {children}
    </Paragraph>
  );
};

PageHeadingBanner.Body = function Body({
  children,
  className,
}: PageHeaderBannerSubElementsProps) {
  const combinedClassName = cn(classes.body, className);

  return <div className={combinedClassName}>{children}</div>;
};
